import { gql, useMutation, useQuery } from "@apollo/client";
import { Button, Divider, Form, Input, Select } from "antd";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Card, CardBody } from "reactstrap";
import Loader from "../../Loader";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import findPlantId from "../../Controllers/findPlantId";
import ReturnBtnComponent from "./returnBtn";
import { useSelector } from "react-redux";

const GET_PLANTS_LIST = gql`
  query ($date: Date) {
    GetPlants(date: $date) {
      plants {
        plant_id
        fact_name
      }
    }
  }
`;
const CREATE_TICKET = gql`
  mutation Mutation($ticketInput: TicketInput) {
    CreateTicket(TicketInput: $ticketInput) {
      title
      content
      categorie
      created
      status
      source
      ticket_id
      user_id
    }
  }
`;

const NewTicketPage = () => {
  const dashboardID = findPlantId();
  const lang_choiced = useSelector((state) => state.lang_change);


  const [form] = Form.useForm();

  const [contentState, setContentState] = useState();
  const [plantsList, setPlantsList] = useState([]);
  const { loading } = useQuery(GET_PLANTS_LIST, {
    // variables: { date: new Date() },
    onCompleted: (res) => {
      setPlantsList(res.GetPlants.plants);
    },
    onError: (err) => {
      toast.error("مشکلی در ارتباط با سرور رخ داده است!");
    },
  });
  const [createTicket] = useMutation(CREATE_TICKET, {
    onCompleted: (res) => {
      //   console.log(res);
      toast.success("تیکت باموفقیت ارسال شد!");
      window.location.replace(`/#/tickets`);
    },
    onError: (err) => {
      // console.log(err);
      toast.error("در ارسال تیکت مشکلی رخ داده است!");
    },
  });
  //   console.log(plantsList);
  //   console.log(editorState)

  const onFinish = (value) => {
    const { title, categorie, source } = value;
    //   console.log(value,contentState);
    const created = new Date();
    createTicket({
      variables: {
        ticketInput: {
          created,
          content: contentState,
          title,
          categorie,
          source,
        },
      },
    });
  };
  const onFinishFailed = (err) => {
    toast.error("لطفا مقادیر را به درستی وارد کنید!");
  };

  if (loading) return <Loader />;
  else
    return (
      <div className="animated fadeIn">
        <Card>
          <Divider>
            <h3>{lang_choiced.pages.tickets.create.title}</h3>
          </Divider>
          <CardBody>
            <div className="text-left mb-4">
              <ReturnBtnComponent />
            </div>
            <Form
              form={form}
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 20,
              }}
              initialValues={{ source: "0", categorie: "support" }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                name="title"
                label={lang_choiced.pages.tickets.create.forms.title}
                rules={[
                  {
                    required: true,
                    message: "لطفا عنوان تیکت خود را وارد کنید!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label={lang_choiced.pages.tickets.create.description}
                rules={[
                  { required: true, message: "لطفا متن تیکت خود را بنویسید!" },
                ]}
              >
                <CKEditor
                  editor={ClassicEditor}
                  data={contentState}
                  //   onReady={(editor) => {
                  //     // You can store the "editor" and use when it is needed.
                  //     console.log("Editor is ready to use!", editor);
                  //   }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log({ event, editor, data });
                    setContentState(data);
                  }}
                  //   onBlur={(event, editor) => {
                  //     console.log("Blur.", editor);
                  //   }}
                  //   onFocus={(event, editor) => {
                  // console.log("Focus.", editor);
                  //   }}
                />
              </Form.Item>
              <Form.Item name="categorie" label={lang_choiced.pages.tickets.create.title}>
                <Select>
                  <Select.Option key="support">{lang_choiced.pages.tickets.create.forms.categories.selectors[0]}</Select.Option>
                  <Select.Option key="administrative">{lang_choiced.pages.tickets.create.forms.categories.selectors[1]}</Select.Option>
                  <Select.Option key="financial">{lang_choiced.pages.tickets.create.forms.categories.selectors[2]}</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item name="source" label={lang_choiced.pages.tickets.create.forms.origin.title}>
                <Select>
                  <Select.Option key={"0"}>{lang_choiced.pages.tickets.create.forms.origin.selectors[0]}</Select.Option>
                  {plantsList.map((item, index) => {
                    return (
                      <Select.Option key={item.plant_id}>
                        {item.fact_name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item>
                <Button
                  disabled={contentState ? false : true}
                  htmlType="submit"
                >
                  {lang_choiced.pages.tickets.create.btnSend}
                </Button>
              </Form.Item>
            </Form>
          </CardBody>
        </Card>
      </div>
    );
};

export default NewTicketPage;
